import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbCollapse } from '@ng-bootstrap/ng-bootstrap';
import { EditStructuralUnitComponent } from 'components/modal/edit-structural-unit/edit-structural-unit.component';
import { StructuralUnitCard } from 'types/structural-unit.interface';
import { CLAIM_SCOPES, CLAIM_TYPES } from 'types/user.interface';
import { ClaimDirective } from 'src/app/directive/claim.directive';

@Component({
  selector: 'app-structural-unit',
  standalone: true,
  imports: [NgbCollapse, NgClass, EditStructuralUnitComponent, ClaimDirective],
  templateUrl: './structural-unit.component.html',
  styleUrl: './structural-unit.component.scss'
})
export class StructuralUnitComponent {
  public readonly CLAIM_TYPES = CLAIM_TYPES;
  public readonly CLAIM_SCOPE = CLAIM_SCOPES['structuralUnit'];

  @Input() structuralUnit!: StructuralUnitCard;
  @Input() isCrudLoading: boolean = false;
  @Output() structuralUnitEdit: EventEmitter<StructuralUnitCard> = new EventEmitter<StructuralUnitCard>();
  isCollapsed: boolean = false;

  updateStructuralUnit(structuralUnit: StructuralUnitCard): void {
    this.structuralUnitEdit.emit(structuralUnit);
  }
}
